import api from './api';

import type { ActionContext } from 'vuex';
import type { State } from '@/typings/vuex';
import type { State as OpenLibraryState, Course, CourseDetail } from './vuex.d';
import type { CourseType } from '@/views/Enrollments/List/index.d';

export default {
  async getCourses(
    context: ActionContext<OpenLibraryState, State>,
    page?: number,
  ): Promise<Course[]> {
    const { sort } = context.state;
    const { courseFilterPayload } = context.getters;
    const pageNumber = page ?? context.state.pageNumber;
    const courses = await api.getCourses(pageNumber, sort, courseFilterPayload);

    if (page) {
      context.commit('setPageNumber', pageNumber);
      context.commit('loadMoreCourses', courses);
    } else {
      context.commit('setCourses', courses);
    }

    return courses;
  },

  async getCourse(
    context: ActionContext<OpenLibraryState, State>,
    courseId: number,
  ): Promise<CourseDetail> {
    const course = await api.getCourse(courseId);

    context.commit('setCourse', course);

    return course;
  },

  async enrollToCourse(
    context: ActionContext<OpenLibraryState, State>,
    courseId: number,
  ): Promise<CourseDetail> {
    const course = await api.enrollToCourse(courseId);

    context.commit('setCourse', course);

    return course;
  },

  async getCourseTypes(): Promise<CourseType[]> {
    return api.getCourseTypes();
  },
};
